<template>
  <section
    id="aboutme"
    class="overflow-hidden"
  >
    <v-row
      class="white"
      no-gutters
    >
      <v-col
        class="hidden-sm-and-down"
        md="6"
      >
        <v-img
          :src="require('@/assets/aboutme.jpg')"
          height="100%"
        />
      </v-col>

      <v-col
        class="align-content-space-between layout wrap pt-5"
        cols="12"
        md="6"
        :pa-5="$vuetify.breakpoint.smAndDown"
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="10"
          >
            <base-heading>
              About Me
            </base-heading>

            <base-text class="mb-5">
              <p>Christopher is a very approachable therapist with years of experience working in Sports Medicine clinics. He enjoys treating a variety of conditions including general body aches and pains, sports injuries, neck and shoulder dysfunction, whiplash associated disorders and postural dysfunctions.</p>
              <p>Christopher is skilled at providing massage therapy for relaxation and/or rehabilitation. With a warm and engaging personality, he offers a customized approach to each patient that can incorporate a variety of massage techniques and complimentary modalities. For musculoskeletal conditions/injuries this may include techniques to help speed recovery include active/passive release for myofascial restrictions and scar tissue, electro-acupuncture for soft-tissue injury and chronic pain, and deep tissue massage.</p>
              <p>Christopher is a graduate of the Everest College Massage Therapy Program and is a recognized Registered Massage Therapist with the College of Massage Therapists of Ontario. He has also completed the McMaster University Contemporary Medical Acupuncture Program. Christopher continues to pursue new learning in order to advance his knowledge and skill in massage and complimentary therapies.</p>
            </base-text>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </section>
</template>

<script>
  export default {
    data: () => ({
      skills: [
        {
          name: 'Web Design',
          value: 100,
        },
        {
          name: 'Web Development',
          value: 75,
        },
        {
          name: 'Web Support',
          value: 90,
        },
      ],
    }),
  }
</script>
